import { RecordOf } from 'immutable';
import { Action } from 'redux';
import { isType } from 'typescript-fsa';

import { getInitialState } from 'shared/helpers/reducer';
import * as storeActions from 'store/entry/actions';

import { EntryHomeState } from './types';

const defaultValues: EntryHomeState = {
  isVerifying: false,
};

export const initialState = getInitialState<EntryHomeState>(defaultValues);

export default (
  state: RecordOf<EntryHomeState> = initialState,
  action: Action,
): RecordOf<EntryHomeState> => {
  if (isType(action, storeActions.getEntry.async.started)) {
    return state.set('isVerifying', true);
  }

  if (isType(action, storeActions.getEntry.async.done)) {
    return state.set('isVerifying', false);
  }

  if (isType(action, storeActions.getEntry.async.failed)) {
    return state.set('isVerifying', false);
  }

  return state;
};
